import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 5,
};

export const microQualificationListTableControllerSlice = createSlice({
    name: 'microQualificationListTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const {changeCurrentPage} = microQualificationListTableControllerSlice.actions;

export default microQualificationListTableControllerSlice.reducer;